import { apiService } from '../api'
import { map } from 'lodash';

const ENDPOINTS = {
  ONLINE_CREATE: '/online-language/save',
  ONLINE_UPDATE: '/online-language/update',
  ONLINE_GET: '/online-language',
  ONLINE_DELETE: '/online-language',
  ONLINE_UPLOAD: '/online-import-csv',
  ONLINE_TOOLTIPS_UPLOAD: '/online-import-tooltips-translations-csv',
}

class LanguageService {
  async onLineCreate(data) {
    return await apiService.post(ENDPOINTS.ONLINE_CREATE, data)
  }

  async onLineUpdate(data) {
    return await apiService.post(ENDPOINTS.ONLINE_UPDATE, data)
  }

  async getOnLineAllWithPagination(page, limit) {
    return await apiService.get(`${ENDPOINTS.ONLINE_GET}?page=${page}&limit=${limit}`)
  }

  async getAllOnlineLanguages() {
    return await apiService.get(ENDPOINTS.ONLINE_GET)
  }

  async onlineDelete(id) {
    return await apiService.delete(`${ENDPOINTS.ONLINE_DELETE}/${id}`);
  }

  async uploadOnlineCSVFile(data, id) {
    return await apiService.upload(`${ENDPOINTS.ONLINE_UPLOAD}?id=${id}`, data);
  }

  async uploadOnlineTooltipsTranslationsFile(data, id) {
    return await apiService.upload(`${ENDPOINTS.ONLINE_TOOLTIPS_UPLOAD}?languageId=${id}`, data);
  }

  formatDataForTable(response) {
    return map(response, data => {
      return {
        language: data,
        rowData: {
          name: data.name,
          code: data.code,
        }
      }
    });
  }
}

export const languageService = new LanguageService()
